<template>
  <div class="pinklist" ref="container">
    <div class="top">
      <img v-if="num !== 0" class="" :src="background" />
      <img
        v-if="type == 'new'"
        class=""
        :src="base_url + '/uploads/routine/imgs/new_top.png'"
      />
      <img
        v-if="type == 'hot'"
        class=""
        :src="base_url + '/uploads/routine/imgs/hot_top.png'"
      />
    </div>
    <div class="list">
      <div
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in goodsList"
        :key="index"
        @click="godetail(item.id)"
      >
        <div class="top1 acea-row row-between-wrapper">
          <img class="goods_img" :src="item.image" />
          <div class="infos">
            <div class="store_name line1">{{ item.store_name }}</div>
            <div class="progress">
              <div
                class="sel"
                :style="{
                  width: (item.pt_info.num / item.pt_info.ptnum) * 100 + '%'
                }"
              ></div>
              <span class="a">
                {{ (item.pt_info.num / item.pt_info.ptnum) * 100 }}%
              </span>
            </div>
            <div class="num acea-row row-between-wrapper">
              <div class="imgs acea-row">
                <img
                  v-for="(i, ind) in item.pt_info.user"
                  :key="ind"
                  :style="{ left: 4.27 * ind + 'vw' }"
                  class=""
                  :src="i.avatar"
                />
              </div>
              <div class="a">{{ item.pt_info.num }}人已拼团</div>
            </div>
            <div class="price acea-row">
              <div class="price_1">
                ￥<span class="a">{{ item.price }}</span>
              </div>
              <div class="ot_price">￥{{ item.ot_price }}</div>
            </div>
          </div>
        </div>
        <div
          class="bottom acea-row row-between-wrapper"
          :style="{
            backgroundImage:
              'url(' + base_url + '/uploads/routine/imgs/pinklist_bg.png)'
          }"
        >
          <div class="left acea-row">
            <img class="red_icon" src="@assets/images/red_icon.png" />
            <div class="bottom_info acea-row">
              <div class="top2">
                <span class="a">{{ item.pt_info.ptnum }}</span>
                人拼团
                <span class="a">{{ item.pt_info.zjnum }}</span>
                人拼中
              </div>
              <div class="bottom1">
                未拼中立得:<span class="a">￥</span>
                <span class="b">{{ item.pt_info.ctj }}</span>
              </div>
            </div>
          </div>
          <div class="right">立即拼团</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGroomList, getProductslist, group_background } from "@api/store";
import { VUE_APP_IMG_URL } from "@utils";
export default {
  name: "pinklist",
  data() {
    return {
      type: "",
      num: 0,
      base_url: VUE_APP_IMG_URL,
      page: 1,
      limit: 10,
      background: "",
      goodsList: []
    };
  },
  mounted() {
    this.$scroll(this.$refs.container, () => {
      if (this.$route.query.type == "hot") {
        !this.loading && this.gethotpinklist();
      } else {
        !this.loading && this.getnewpinklist();
      }
    });
  },
  created() {
    if (this.$route.query.num) {
      this.num = this.$route.query.num;
      this.getGround();
      this.getnewpinklist();
    }
    if (this.$route.query.type == "new") {
      this.type = this.$route.query.type;
      this.getnewpinklist();
    } else if (this.$route.query.type == "hot") {
      this.type = this.$route.query.type;
      this.gethotpinklist();
    }
  },
  methods: {
    godetail(id) {
      this.$router.push({
        path: "/detail/" + id
      });
    },
    getGround() {
      let data = {
        num: this.num
      };
      group_background(data)
        .then(res => {
          this.background = res.msg;
        })
        .catch(res => {
          console.log(res);
        });
    },
    // 获取热门拼团列表
    gethotpinklist() {
      var that = this;
      if (that.loadend) return;
      if (that.loading) return;
      this.loading = true;
      let data = {
        page: this.page,
        limit: this.limit
      };
      getGroomList(2, data)
        .then(res => {
          var list = res.data.list || [];
          that.loadend = list.length < that.limit;
          that.loading = false;
          that.page = that.page + 1;
          that.goodsList = that.goodsList.concat(list);
        })
        .catch(res => {
          console.log(res);
        });
    },
    // 获取新人拼团列表
    getnewpinklist() {
      var that = this;
      if (that.loadend) return;
      if (that.loading) return;
      this.loading = true;
      let data;
      // 新人专区
      if (this.type) {
        data = {
          page: this.page,
          limit: this.limit,
          sid: 23
        };
      }
      // 3-10-50拼团专区
      if (this.num) {
        data = {
          page: this.page,
          limit: this.limit,
          ptnum: this.num
        };
      }
      getProductslist(data)
        .then(res => {
          var list = res.data || [];
          that.loadend = list.length < that.limit;
          that.loading = false;
          that.page = that.page + 1;
          that.goodsList = that.goodsList.concat(list);
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.pinklist {
  .top {
    width: 100vw;
    height: 110vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .list {
    width: 100%;
    padding: 0 2.67vw;
    margin-top: -50.67vw;
    z-index: 1;
    position: relative;
    .item {
      width: 100%;
      background-color: #ffffff;
      border-radius: 3vw;
      height: 50.67vw;
      margin-bottom: 2.67vw;
      padding: 2.67vw;
      flex-direction: column;
      .top1 {
        width: 100%;
        .goods_img {
          width: 29.33vw;
          height: 29.33vw;
          border-radius: 1vw;
        }
        .infos {
          width: 57vw;
          .store_name {
            font-size: 3.47vw;
            color: #333333;
            font-weight: 600;
          }
          .progress {
            width: 100%;
            height: 2.67vw;
            background-color: rgba(255, 67, 64, 0.3);
            border-radius: 1vw;
            position: relative;
            margin: 4vw 0 2.8vw;
            .sel {
              height: 100%;
              border-radius: 1vw;
              background-color: #ff4a2d;
            }
            .a {
              color: #fff;
              width: 100%;
              position: absolute;
              text-align: center;
              top: 0;
              left: 0;
              font-size: 2.93vw;
              line-height: 2.67vw;
            }
          }
          .num {
            .imgs {
              position: relative;
              height: 5.07vw;
              img {
                position: absolute;
                width: 5.07vw;
                height: 5.07vw;
                border-radius: 50%;
              }
            }
            .a {
              color: #333333;
              font-size: 3.2vw;
            }
          }
          .price {
            align-items: center;
            margin-top: 3vw;
            .price_1 {
              font-size: 3.47vw;
              color: #333333;
              font-weight: 600;
              .a {
                font-size: 4.8vw;
              }
            }
            .ot_price {
              color: #999999;
              font-size: 3.47vw;
            }
          }
        }
      }
      .bottom {
        width: 100%;
        height: 13.33vw;
        background-size: 100% 100%;
        padding: 0 6.93vw 0 3.47vw;
        .left {
          height: 100%;
          align-items: center;
          .red_icon {
            width: 7.2vw;
            height: 7.2vw;
            margin-right: 2vw;
          }
          .bottom_info {
            flex-direction: column;
            // align-items: center;
            .top2 {
              font-size: 2.93vw;
              color: #333333;
              .a {
                color: #ff4142;
              }
            }
            .bottom1 {
              line-height: 4vw;
              font-size: 3.2vw;
              color: #333333;
              .a {
                color: #ff4142;
                font-size: 3.47vw;
                font-weight: 600;
              }
              .b {
                font-weight: 600;
                font-size: 4.8vw;
                color: #ff4142;
              }
            }
          }
        }
        .right {
          color: #fff;
          font-size: 4vw;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
